<script setup lang="ts">
import FooterBar from '@/components/footer-bar/FooterBar.vue'
import { ref } from 'vue'
import Enchant from './components/Enchant.vue'
import Extract from './components/Extract.vue'
import SeniorReinforce from './components/SeniorReinforce.vue'

const curTab = ref('enchant')
</script>

<template>
  <div class="smithy-page page">
    <h2>秘术坊</h2>

    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="附魔" name="enchant" class="pane" lazy>
        <Enchant class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="萃取" name="extract" class="pane" lazy>
        <Extract class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="高阶强化" name="seniorReinforce" class="pane" lazy>
        <SeniorReinforce class="pane-item" />
      </el-tab-pane>
    </el-tabs>
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.smithy-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
